module.exports = __webpack_public_path__ + "static/media/7.f1d77147.jpg";